import { unstable_HistoryRouter as HistoryRouter, Routes, Route, Navigate } from 'react-router-dom';
import StepperForm from './Pages/StepperForm/StepperForm';
import Layout from './Components/Layout';
import DisclaimerForm from './Pages/DisclaimerForm';
import SubmissionComplete from './Pages/StepperForm/Components/SubmissionStatus/SubmissionComplete';
import LoginPage from './Pages/LoginPage';
import Dashboard from './Pages/Dashboard';
import ProtectedRoute from './Auth/ProtectedRoute';
import ApplicationDetail from './Pages/ApplicationDetail';
import { history } from './Utils/AxiosClient';
import { HotjarSetup } from './Utils/Hotjar';
// import { GTM } from './Utils/GTM';

function App() {
  HotjarSetup();

  return (
    <HistoryRouter history={history} basename="/eccta-compliance">
      <Routes>
        {/* Routes without Layout */}
        <Route path="/login" element={<LoginPage />} />

        {/* Routes with Layout */}
        <Route element={<Layout />}>
          <Route path="/" element={<Navigate to="/disclaimerform" replace />} />
          <Route path="/disclaimerform" element={<DisclaimerForm />} />
          <Route path="/stepperform" element={<StepperForm />} />
          <Route path="/submissioncomplete/:sessionId" element={<SubmissionComplete />} />
          {/* Protected Routes */}
          <Route element={<ProtectedRoute />}>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/applicationDetail/:id" element={<ApplicationDetail />} />
          </Route>
        </Route>

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </HistoryRouter>
  );
}

export default App;
